module.exports = __webpack_public_path__ + "img/safe.87383a99.svg";